/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * GetDocument.Insider
 * OpenAPI spec version: 1.0.0
 */
import {
    HttpClient,
    HttpHeaders,
    HttpResponse as AngularHttpResponse,
} from '@angular/common/http';
import type { HttpContext, HttpEvent, HttpParams } from '@angular/common/http';

import { Injectable, inject } from '@angular/core';

import { Observable } from 'rxjs';

import type {
    BuildingOwnershipTransferListResponse,
    BuildingOwnershipTransferResponse,
    ChangeOrganisationUserRoleRequest,
    ChangeOrganisationUserRoleResponse,
    CreateOrganisationDocumentPackTemplateRequest,
    CreateOrganisationRequest,
    DecideBuildingOwnershipTransferRequest,
    DuplicateOrganisationDocumentPackTemplateRequest,
    InviteOrganisationUserRequest,
    ListOrganisationDocumentPackTemplatesParams,
    ListOrganisationUsersParams,
    OrganisationDocumentPackTemplateListResponse,
    OrganisationDocumentPackTemplateResponse,
    OrganisationResponse,
    OrganisationUserBuildingAccessResponse,
    OrganisationUserListResponse,
    RecipientBatchResponseOfInviteOrganisationUserResponse,
    ReinviteOrganisationUserRequest,
    UpdateOrganisationDocumentPackTemplateRequest,
    UpdateOrganisationNameRequest,
    UpdateOrganisationUserBuildingAccessRequest,
} from '../core-models';

interface HttpClientOptions {
    readonly headers?: HttpHeaders | Record<string, string | string[]>;
    readonly context?: HttpContext;
    readonly params?:
        | HttpParams
        | Record<
              string,
              string | number | boolean | Array<string | number | boolean>
          >;
    readonly reportProgress?: boolean;
    readonly withCredentials?: boolean;
    readonly credentials?: RequestCredentials;
    readonly keepalive?: boolean;
    readonly priority?: RequestPriority;
    readonly cache?: RequestCache;
    readonly mode?: RequestMode;
    readonly redirect?: RequestRedirect;
    readonly referrer?: string;
    readonly integrity?: string;
    readonly referrerPolicy?: ReferrerPolicy;
    readonly transferCache?: { includeHeaders?: string[] } | boolean;
    readonly timeout?: number;
}

type HttpClientBodyOptions = HttpClientOptions & {
    readonly observe?: 'body';
};

type HttpClientEventOptions = HttpClientOptions & {
    readonly observe: 'events';
};

type HttpClientResponseOptions = HttpClientOptions & {
    readonly observe: 'response';
};

type HttpClientObserveOptions = HttpClientOptions & {
    readonly observe?: 'body' | 'events' | 'response';
};

type AngularHttpParamValue =
    | string
    | number
    | boolean
    | Array<string | number | boolean>;
type AngularHttpParamValueWithNullable = AngularHttpParamValue | null;

function filterParams(
    params: Record<string, unknown>,
    requiredNullableKeys?: ReadonlySet<string>,
    preserveRequiredNullables?: false,
    passthroughKeys?: undefined
): Record<string, AngularHttpParamValue>;
function filterParams(
    params: Record<string, unknown>,
    requiredNullableKeys: ReadonlySet<string> | undefined,
    preserveRequiredNullables: true,
    passthroughKeys?: undefined
): Record<string, AngularHttpParamValueWithNullable>;
function filterParams(
    params: Record<string, unknown>,
    requiredNullableKeys: ReadonlySet<string> | undefined,
    preserveRequiredNullables: boolean | undefined,
    passthroughKeys: ReadonlySet<string>
): Record<string, unknown>;
function filterParams(
    params: Record<string, unknown>,
    requiredNullableKeys: ReadonlySet<string> = new Set(),
    preserveRequiredNullables = false,
    passthroughKeys: ReadonlySet<string> = new Set()
): Record<string, unknown> {
    const filteredParams: Record<string, unknown> = {};
    for (const [key, value] of Object.entries(params)) {
        if (passthroughKeys.has(key)) {
            if (value !== undefined) {
                filteredParams[key] = value;
            }
            continue;
        }
        if (Array.isArray(value)) {
            const filtered = value.filter(
                (item) =>
                    item != null &&
                    (typeof item === 'string' ||
                        typeof item === 'number' ||
                        typeof item === 'boolean')
            ) as Array<string | number | boolean>;
            if (filtered.length) {
                filteredParams[key] = filtered;
            }
        } else if (value === null && requiredNullableKeys.has(key)) {
            // With a paramsSerializer (preserveRequiredNullables) the literal null
            // is passed through for it to consume; without one, emit an empty
            // string so the required key still reaches the wire as `?key=`
            // instead of being silently dropped. See #3712.
            filteredParams[key] = preserveRequiredNullables ? null : '';
        } else if (
            value != null &&
            (typeof value === 'string' ||
                typeof value === 'number' ||
                typeof value === 'boolean')
        ) {
            filteredParams[key] = value;
        }
    }
    return filteredParams;
}

@Injectable({ providedIn: 'root' })
export class OrganisationsApiService {
    private readonly http = inject(HttpClient);
    /**
     * Creates a new organisation record.
     * @summary Create organisation
     */
    createOrganisation<TData = OrganisationResponse>(
        createOrganisationRequest: CreateOrganisationRequest,
        options?: HttpClientBodyOptions
    ): Observable<TData>;
    createOrganisation<TData = OrganisationResponse>(
        createOrganisationRequest: CreateOrganisationRequest,
        options?: HttpClientEventOptions
    ): Observable<HttpEvent<TData>>;
    createOrganisation<TData = OrganisationResponse>(
        createOrganisationRequest: CreateOrganisationRequest,
        options?: HttpClientResponseOptions
    ): Observable<AngularHttpResponse<TData>>;
    createOrganisation<TData = OrganisationResponse>(
        createOrganisationRequest: CreateOrganisationRequest,
        options?: HttpClientObserveOptions
    ): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
        if (options?.observe === 'events') {
            return this.http.post<TData>(
                `/@core/api/organisations`,
                createOrganisationRequest,
                {
                    ...(options as Omit<
                        NonNullable<typeof options>,
                        'observe'
                    >),
                    observe: 'events',
                }
            );
        }

        if (options?.observe === 'response') {
            return this.http.post<TData>(
                `/@core/api/organisations`,
                createOrganisationRequest,
                {
                    ...(options as Omit<
                        NonNullable<typeof options>,
                        'observe'
                    >),
                    observe: 'response',
                }
            );
        }

        return this.http.post<TData>(
            `/@core/api/organisations`,
            createOrganisationRequest,
            {
                ...(options as Omit<NonNullable<typeof options>, 'observe'>),
                observe: 'body',
            }
        );
    }
    /**
     * Soft deletes an owner organisation when it has no active published buildings.
     * @summary Delete organisation
     */
    removeOrganisation<TData = void>(
        organisationId: string,
        options?: HttpClientBodyOptions
    ): Observable<TData>;
    removeOrganisation<TData = void>(
        organisationId: string,
        options?: HttpClientEventOptions
    ): Observable<HttpEvent<TData>>;
    removeOrganisation<TData = void>(
        organisationId: string,
        options?: HttpClientResponseOptions
    ): Observable<AngularHttpResponse<TData>>;
    removeOrganisation<TData = void>(
        organisationId: string,
        options?: HttpClientObserveOptions
    ): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
        if (options?.observe === 'events') {
            return this.http.delete<TData>(
                `/@core/api/organisations/${organisationId}`,
                {
                    ...(options as Omit<
                        NonNullable<typeof options>,
                        'observe'
                    >),
                    observe: 'events',
                }
            );
        }

        if (options?.observe === 'response') {
            return this.http.delete<TData>(
                `/@core/api/organisations/${organisationId}`,
                {
                    ...(options as Omit<
                        NonNullable<typeof options>,
                        'observe'
                    >),
                    observe: 'response',
                }
            );
        }

        return this.http.delete<TData>(
            `/@core/api/organisations/${organisationId}`,
            {
                ...(options as Omit<NonNullable<typeof options>, 'observe'>),
                observe: 'body',
            }
        );
    }
    /**
     * Retrieves an organisation and overview summary counts by its ID.
     * @summary Get organisation by ID
     */
    getOrganisationById<TData = OrganisationResponse>(
        organisationId: string,
        options?: HttpClientBodyOptions
    ): Observable<TData>;
    getOrganisationById<TData = OrganisationResponse>(
        organisationId: string,
        options?: HttpClientEventOptions
    ): Observable<HttpEvent<TData>>;
    getOrganisationById<TData = OrganisationResponse>(
        organisationId: string,
        options?: HttpClientResponseOptions
    ): Observable<AngularHttpResponse<TData>>;
    getOrganisationById<TData = OrganisationResponse>(
        organisationId: string,
        options?: HttpClientObserveOptions
    ): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
        if (options?.observe === 'events') {
            return this.http.get<TData>(
                `/@core/api/organisations/${organisationId}`,
                {
                    ...(options as Omit<
                        NonNullable<typeof options>,
                        'observe'
                    >),
                    observe: 'events',
                }
            );
        }

        if (options?.observe === 'response') {
            return this.http.get<TData>(
                `/@core/api/organisations/${organisationId}`,
                {
                    ...(options as Omit<
                        NonNullable<typeof options>,
                        'observe'
                    >),
                    observe: 'response',
                }
            );
        }

        return this.http.get<TData>(
            `/@core/api/organisations/${organisationId}`,
            {
                ...(options as Omit<NonNullable<typeof options>, 'observe'>),
                observe: 'body',
            }
        );
    }
    /**
     * Updates an organisation's display name.
     * @summary Update organisation name
     */
    updateOrganisation<TData = OrganisationResponse>(
        organisationId: string,
        updateOrganisationNameRequest: UpdateOrganisationNameRequest,
        options?: HttpClientBodyOptions
    ): Observable<TData>;
    updateOrganisation<TData = OrganisationResponse>(
        organisationId: string,
        updateOrganisationNameRequest: UpdateOrganisationNameRequest,
        options?: HttpClientEventOptions
    ): Observable<HttpEvent<TData>>;
    updateOrganisation<TData = OrganisationResponse>(
        organisationId: string,
        updateOrganisationNameRequest: UpdateOrganisationNameRequest,
        options?: HttpClientResponseOptions
    ): Observable<AngularHttpResponse<TData>>;
    updateOrganisation<TData = OrganisationResponse>(
        organisationId: string,
        updateOrganisationNameRequest: UpdateOrganisationNameRequest,
        options?: HttpClientObserveOptions
    ): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
        if (options?.observe === 'events') {
            return this.http.patch<TData>(
                `/@core/api/organisations/${organisationId}`,
                updateOrganisationNameRequest,
                {
                    ...(options as Omit<
                        NonNullable<typeof options>,
                        'observe'
                    >),
                    observe: 'events',
                }
            );
        }

        if (options?.observe === 'response') {
            return this.http.patch<TData>(
                `/@core/api/organisations/${organisationId}`,
                updateOrganisationNameRequest,
                {
                    ...(options as Omit<
                        NonNullable<typeof options>,
                        'observe'
                    >),
                    observe: 'response',
                }
            );
        }

        return this.http.patch<TData>(
            `/@core/api/organisations/${organisationId}`,
            updateOrganisationNameRequest,
            {
                ...(options as Omit<NonNullable<typeof options>, 'observe'>),
                observe: 'body',
            }
        );
    }
    /**
     * Lists pending building ownership transfer requests for a recipient organisation.
     * @summary List pending building ownership transfers
     */
    listOrganisationBuildingOwnershipTransfers<
        TData = BuildingOwnershipTransferListResponse,
    >(
        organisationId: string,
        options?: HttpClientBodyOptions
    ): Observable<TData>;
    listOrganisationBuildingOwnershipTransfers<
        TData = BuildingOwnershipTransferListResponse,
    >(
        organisationId: string,
        options?: HttpClientEventOptions
    ): Observable<HttpEvent<TData>>;
    listOrganisationBuildingOwnershipTransfers<
        TData = BuildingOwnershipTransferListResponse,
    >(
        organisationId: string,
        options?: HttpClientResponseOptions
    ): Observable<AngularHttpResponse<TData>>;
    listOrganisationBuildingOwnershipTransfers<
        TData = BuildingOwnershipTransferListResponse,
    >(
        organisationId: string,
        options?: HttpClientObserveOptions
    ): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
        if (options?.observe === 'events') {
            return this.http.get<TData>(
                `/@core/api/organisations/${organisationId}/building-ownership-transfers`,
                {
                    ...(options as Omit<
                        NonNullable<typeof options>,
                        'observe'
                    >),
                    observe: 'events',
                }
            );
        }

        if (options?.observe === 'response') {
            return this.http.get<TData>(
                `/@core/api/organisations/${organisationId}/building-ownership-transfers`,
                {
                    ...(options as Omit<
                        NonNullable<typeof options>,
                        'observe'
                    >),
                    observe: 'response',
                }
            );
        }

        return this.http.get<TData>(
            `/@core/api/organisations/${organisationId}/building-ownership-transfers`,
            {
                ...(options as Omit<NonNullable<typeof options>, 'observe'>),
                observe: 'body',
            }
        );
    }
    /**
     * Accepts or rejects a pending building ownership transfer request.
     * @summary Decide a building ownership transfer
     */
    createOrganisationBuildingOwnershipTransfer<
        TData = BuildingOwnershipTransferResponse,
    >(
        organisationId: string,
        transferId: string,
        decideBuildingOwnershipTransferRequest: DecideBuildingOwnershipTransferRequest,
        options?: HttpClientBodyOptions
    ): Observable<TData>;
    createOrganisationBuildingOwnershipTransfer<
        TData = BuildingOwnershipTransferResponse,
    >(
        organisationId: string,
        transferId: string,
        decideBuildingOwnershipTransferRequest: DecideBuildingOwnershipTransferRequest,
        options?: HttpClientEventOptions
    ): Observable<HttpEvent<TData>>;
    createOrganisationBuildingOwnershipTransfer<
        TData = BuildingOwnershipTransferResponse,
    >(
        organisationId: string,
        transferId: string,
        decideBuildingOwnershipTransferRequest: DecideBuildingOwnershipTransferRequest,
        options?: HttpClientResponseOptions
    ): Observable<AngularHttpResponse<TData>>;
    createOrganisationBuildingOwnershipTransfer<
        TData = BuildingOwnershipTransferResponse,
    >(
        organisationId: string,
        transferId: string,
        decideBuildingOwnershipTransferRequest: DecideBuildingOwnershipTransferRequest,
        options?: HttpClientObserveOptions
    ): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
        if (options?.observe === 'events') {
            return this.http.post<TData>(
                `/@core/api/organisations/${organisationId}/building-ownership-transfers/${transferId}`,
                decideBuildingOwnershipTransferRequest,
                {
                    ...(options as Omit<
                        NonNullable<typeof options>,
                        'observe'
                    >),
                    observe: 'events',
                }
            );
        }

        if (options?.observe === 'response') {
            return this.http.post<TData>(
                `/@core/api/organisations/${organisationId}/building-ownership-transfers/${transferId}`,
                decideBuildingOwnershipTransferRequest,
                {
                    ...(options as Omit<
                        NonNullable<typeof options>,
                        'observe'
                    >),
                    observe: 'response',
                }
            );
        }

        return this.http.post<TData>(
            `/@core/api/organisations/${organisationId}/building-ownership-transfers/${transferId}`,
            decideBuildingOwnershipTransferRequest,
            {
                ...(options as Omit<NonNullable<typeof options>, 'observe'>),
                observe: 'body',
            }
        );
    }
    /**
     * @summary List organisation document pack templates
     */
    listOrganisationDocumentPackTemplates<
        TData = OrganisationDocumentPackTemplateListResponse,
    >(
        organisationId: string,
        params: ListOrganisationDocumentPackTemplatesParams,
        options?: HttpClientBodyOptions
    ): Observable<TData>;
    listOrganisationDocumentPackTemplates<
        TData = OrganisationDocumentPackTemplateListResponse,
    >(
        organisationId: string,
        params: ListOrganisationDocumentPackTemplatesParams,
        options?: HttpClientEventOptions
    ): Observable<HttpEvent<TData>>;
    listOrganisationDocumentPackTemplates<
        TData = OrganisationDocumentPackTemplateListResponse,
    >(
        organisationId: string,
        params: ListOrganisationDocumentPackTemplatesParams,
        options?: HttpClientResponseOptions
    ): Observable<AngularHttpResponse<TData>>;
    listOrganisationDocumentPackTemplates<
        TData = OrganisationDocumentPackTemplateListResponse,
    >(
        organisationId: string,
        params: ListOrganisationDocumentPackTemplatesParams,
        options?: HttpClientObserveOptions
    ): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
        const filteredParams = filterParams(
            { ...params, ...options?.params },
            new Set<string>([])
        );

        if (options?.observe === 'events') {
            return this.http.get<TData>(
                `/@core/api/organisations/${organisationId}/document-pack-templates`,
                {
                    ...(options as Omit<
                        NonNullable<typeof options>,
                        'observe'
                    >),
                    observe: 'events',
                    params: filteredParams,
                }
            );
        }

        if (options?.observe === 'response') {
            return this.http.get<TData>(
                `/@core/api/organisations/${organisationId}/document-pack-templates`,
                {
                    ...(options as Omit<
                        NonNullable<typeof options>,
                        'observe'
                    >),
                    observe: 'response',
                    params: filteredParams,
                }
            );
        }

        return this.http.get<TData>(
            `/@core/api/organisations/${organisationId}/document-pack-templates`,
            {
                ...(options as Omit<NonNullable<typeof options>, 'observe'>),
                observe: 'body',
                params: filteredParams,
            }
        );
    }
    /**
     * @summary Create organisation document pack template
     */
    createOrganisationDocumentPackTemplate<
        TData = OrganisationDocumentPackTemplateResponse,
    >(
        organisationId: string,
        createOrganisationDocumentPackTemplateRequest: CreateOrganisationDocumentPackTemplateRequest,
        options?: HttpClientBodyOptions
    ): Observable<TData>;
    createOrganisationDocumentPackTemplate<
        TData = OrganisationDocumentPackTemplateResponse,
    >(
        organisationId: string,
        createOrganisationDocumentPackTemplateRequest: CreateOrganisationDocumentPackTemplateRequest,
        options?: HttpClientEventOptions
    ): Observable<HttpEvent<TData>>;
    createOrganisationDocumentPackTemplate<
        TData = OrganisationDocumentPackTemplateResponse,
    >(
        organisationId: string,
        createOrganisationDocumentPackTemplateRequest: CreateOrganisationDocumentPackTemplateRequest,
        options?: HttpClientResponseOptions
    ): Observable<AngularHttpResponse<TData>>;
    createOrganisationDocumentPackTemplate<
        TData = OrganisationDocumentPackTemplateResponse,
    >(
        organisationId: string,
        createOrganisationDocumentPackTemplateRequest: CreateOrganisationDocumentPackTemplateRequest,
        options?: HttpClientObserveOptions
    ): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
        if (options?.observe === 'events') {
            return this.http.post<TData>(
                `/@core/api/organisations/${organisationId}/document-pack-templates`,
                createOrganisationDocumentPackTemplateRequest,
                {
                    ...(options as Omit<
                        NonNullable<typeof options>,
                        'observe'
                    >),
                    observe: 'events',
                }
            );
        }

        if (options?.observe === 'response') {
            return this.http.post<TData>(
                `/@core/api/organisations/${organisationId}/document-pack-templates`,
                createOrganisationDocumentPackTemplateRequest,
                {
                    ...(options as Omit<
                        NonNullable<typeof options>,
                        'observe'
                    >),
                    observe: 'response',
                }
            );
        }

        return this.http.post<TData>(
            `/@core/api/organisations/${organisationId}/document-pack-templates`,
            createOrganisationDocumentPackTemplateRequest,
            {
                ...(options as Omit<NonNullable<typeof options>, 'observe'>),
                observe: 'body',
            }
        );
    }
    /**
     * @summary Delete organisation document pack template
     */
    removeOrganisationDocumentPackTemplate<TData = void>(
        organisationId: string,
        templateId: string,
        options?: HttpClientBodyOptions
    ): Observable<TData>;
    removeOrganisationDocumentPackTemplate<TData = void>(
        organisationId: string,
        templateId: string,
        options?: HttpClientEventOptions
    ): Observable<HttpEvent<TData>>;
    removeOrganisationDocumentPackTemplate<TData = void>(
        organisationId: string,
        templateId: string,
        options?: HttpClientResponseOptions
    ): Observable<AngularHttpResponse<TData>>;
    removeOrganisationDocumentPackTemplate<TData = void>(
        organisationId: string,
        templateId: string,
        options?: HttpClientObserveOptions
    ): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
        if (options?.observe === 'events') {
            return this.http.delete<TData>(
                `/@core/api/organisations/${organisationId}/document-pack-templates/${templateId}`,
                {
                    ...(options as Omit<
                        NonNullable<typeof options>,
                        'observe'
                    >),
                    observe: 'events',
                }
            );
        }

        if (options?.observe === 'response') {
            return this.http.delete<TData>(
                `/@core/api/organisations/${organisationId}/document-pack-templates/${templateId}`,
                {
                    ...(options as Omit<
                        NonNullable<typeof options>,
                        'observe'
                    >),
                    observe: 'response',
                }
            );
        }

        return this.http.delete<TData>(
            `/@core/api/organisations/${organisationId}/document-pack-templates/${templateId}`,
            {
                ...(options as Omit<NonNullable<typeof options>, 'observe'>),
                observe: 'body',
            }
        );
    }
    /**
     * @summary Get organisation document pack template
     */
    getOrganisationDocumentPackTemplateById<
        TData = OrganisationDocumentPackTemplateResponse,
    >(
        organisationId: string,
        templateId: string,
        options?: HttpClientBodyOptions
    ): Observable<TData>;
    getOrganisationDocumentPackTemplateById<
        TData = OrganisationDocumentPackTemplateResponse,
    >(
        organisationId: string,
        templateId: string,
        options?: HttpClientEventOptions
    ): Observable<HttpEvent<TData>>;
    getOrganisationDocumentPackTemplateById<
        TData = OrganisationDocumentPackTemplateResponse,
    >(
        organisationId: string,
        templateId: string,
        options?: HttpClientResponseOptions
    ): Observable<AngularHttpResponse<TData>>;
    getOrganisationDocumentPackTemplateById<
        TData = OrganisationDocumentPackTemplateResponse,
    >(
        organisationId: string,
        templateId: string,
        options?: HttpClientObserveOptions
    ): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
        if (options?.observe === 'events') {
            return this.http.get<TData>(
                `/@core/api/organisations/${organisationId}/document-pack-templates/${templateId}`,
                {
                    ...(options as Omit<
                        NonNullable<typeof options>,
                        'observe'
                    >),
                    observe: 'events',
                }
            );
        }

        if (options?.observe === 'response') {
            return this.http.get<TData>(
                `/@core/api/organisations/${organisationId}/document-pack-templates/${templateId}`,
                {
                    ...(options as Omit<
                        NonNullable<typeof options>,
                        'observe'
                    >),
                    observe: 'response',
                }
            );
        }

        return this.http.get<TData>(
            `/@core/api/organisations/${organisationId}/document-pack-templates/${templateId}`,
            {
                ...(options as Omit<NonNullable<typeof options>, 'observe'>),
                observe: 'body',
            }
        );
    }
    /**
     * @summary Update organisation document pack template
     */
    updateOrganisationDocumentPackTemplate<
        TData = OrganisationDocumentPackTemplateResponse,
    >(
        organisationId: string,
        templateId: string,
        updateOrganisationDocumentPackTemplateRequest: UpdateOrganisationDocumentPackTemplateRequest,
        options?: HttpClientBodyOptions
    ): Observable<TData>;
    updateOrganisationDocumentPackTemplate<
        TData = OrganisationDocumentPackTemplateResponse,
    >(
        organisationId: string,
        templateId: string,
        updateOrganisationDocumentPackTemplateRequest: UpdateOrganisationDocumentPackTemplateRequest,
        options?: HttpClientEventOptions
    ): Observable<HttpEvent<TData>>;
    updateOrganisationDocumentPackTemplate<
        TData = OrganisationDocumentPackTemplateResponse,
    >(
        organisationId: string,
        templateId: string,
        updateOrganisationDocumentPackTemplateRequest: UpdateOrganisationDocumentPackTemplateRequest,
        options?: HttpClientResponseOptions
    ): Observable<AngularHttpResponse<TData>>;
    updateOrganisationDocumentPackTemplate<
        TData = OrganisationDocumentPackTemplateResponse,
    >(
        organisationId: string,
        templateId: string,
        updateOrganisationDocumentPackTemplateRequest: UpdateOrganisationDocumentPackTemplateRequest,
        options?: HttpClientObserveOptions
    ): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
        if (options?.observe === 'events') {
            return this.http.put<TData>(
                `/@core/api/organisations/${organisationId}/document-pack-templates/${templateId}`,
                updateOrganisationDocumentPackTemplateRequest,
                {
                    ...(options as Omit<
                        NonNullable<typeof options>,
                        'observe'
                    >),
                    observe: 'events',
                }
            );
        }

        if (options?.observe === 'response') {
            return this.http.put<TData>(
                `/@core/api/organisations/${organisationId}/document-pack-templates/${templateId}`,
                updateOrganisationDocumentPackTemplateRequest,
                {
                    ...(options as Omit<
                        NonNullable<typeof options>,
                        'observe'
                    >),
                    observe: 'response',
                }
            );
        }

        return this.http.put<TData>(
            `/@core/api/organisations/${organisationId}/document-pack-templates/${templateId}`,
            updateOrganisationDocumentPackTemplateRequest,
            {
                ...(options as Omit<NonNullable<typeof options>, 'observe'>),
                observe: 'body',
            }
        );
    }
    /**
     * @summary Duplicate organisation document pack template
     */
    duplicateOrganisationDocumentPackTemplate<
        TData = OrganisationDocumentPackTemplateResponse,
    >(
        organisationId: string,
        templateId: string,
        duplicateOrganisationDocumentPackTemplateRequest: DuplicateOrganisationDocumentPackTemplateRequest,
        options?: HttpClientBodyOptions
    ): Observable<TData>;
    duplicateOrganisationDocumentPackTemplate<
        TData = OrganisationDocumentPackTemplateResponse,
    >(
        organisationId: string,
        templateId: string,
        duplicateOrganisationDocumentPackTemplateRequest: DuplicateOrganisationDocumentPackTemplateRequest,
        options?: HttpClientEventOptions
    ): Observable<HttpEvent<TData>>;
    duplicateOrganisationDocumentPackTemplate<
        TData = OrganisationDocumentPackTemplateResponse,
    >(
        organisationId: string,
        templateId: string,
        duplicateOrganisationDocumentPackTemplateRequest: DuplicateOrganisationDocumentPackTemplateRequest,
        options?: HttpClientResponseOptions
    ): Observable<AngularHttpResponse<TData>>;
    duplicateOrganisationDocumentPackTemplate<
        TData = OrganisationDocumentPackTemplateResponse,
    >(
        organisationId: string,
        templateId: string,
        duplicateOrganisationDocumentPackTemplateRequest: DuplicateOrganisationDocumentPackTemplateRequest,
        options?: HttpClientObserveOptions
    ): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
        if (options?.observe === 'events') {
            return this.http.post<TData>(
                `/@core/api/organisations/${organisationId}/document-pack-templates/${templateId}/duplicate`,
                duplicateOrganisationDocumentPackTemplateRequest,
                {
                    ...(options as Omit<
                        NonNullable<typeof options>,
                        'observe'
                    >),
                    observe: 'events',
                }
            );
        }

        if (options?.observe === 'response') {
            return this.http.post<TData>(
                `/@core/api/organisations/${organisationId}/document-pack-templates/${templateId}/duplicate`,
                duplicateOrganisationDocumentPackTemplateRequest,
                {
                    ...(options as Omit<
                        NonNullable<typeof options>,
                        'observe'
                    >),
                    observe: 'response',
                }
            );
        }

        return this.http.post<TData>(
            `/@core/api/organisations/${organisationId}/document-pack-templates/${templateId}/duplicate`,
            duplicateOrganisationDocumentPackTemplateRequest,
            {
                ...(options as Omit<NonNullable<typeof options>, 'observe'>),
                observe: 'body',
            }
        );
    }
    /**
     * Lists active and invited users by default. Status and role filters apply before sorting, pagination and table totals. Inactive users remain visible for 30 days after removal. Summary counts ignore table filters and pagination; role counts include active users only. Defaults to name ascending. Blank values are last in both directions; equal values use user ID ascending.
     * @summary List organisation users
     */
    listOrganisationUsers<TData = OrganisationUserListResponse>(
        organisationId: string,
        params: ListOrganisationUsersParams,
        options?: HttpClientBodyOptions
    ): Observable<TData>;
    listOrganisationUsers<TData = OrganisationUserListResponse>(
        organisationId: string,
        params: ListOrganisationUsersParams,
        options?: HttpClientEventOptions
    ): Observable<HttpEvent<TData>>;
    listOrganisationUsers<TData = OrganisationUserListResponse>(
        organisationId: string,
        params: ListOrganisationUsersParams,
        options?: HttpClientResponseOptions
    ): Observable<AngularHttpResponse<TData>>;
    listOrganisationUsers<TData = OrganisationUserListResponse>(
        organisationId: string,
        params: ListOrganisationUsersParams,
        options?: HttpClientObserveOptions
    ): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
        const filteredParams = filterParams(
            { ...params, ...options?.params },
            new Set<string>([])
        );

        if (options?.observe === 'events') {
            return this.http.get<TData>(
                `/@core/api/organisations/${organisationId}/users`,
                {
                    ...(options as Omit<
                        NonNullable<typeof options>,
                        'observe'
                    >),
                    observe: 'events',
                    params: filteredParams,
                }
            );
        }

        if (options?.observe === 'response') {
            return this.http.get<TData>(
                `/@core/api/organisations/${organisationId}/users`,
                {
                    ...(options as Omit<
                        NonNullable<typeof options>,
                        'observe'
                    >),
                    observe: 'response',
                    params: filteredParams,
                }
            );
        }

        return this.http.get<TData>(
            `/@core/api/organisations/${organisationId}/users`,
            {
                ...(options as Omit<NonNullable<typeof options>, 'observe'>),
                observe: 'body',
                params: filteredParams,
            }
        );
    }
    /**
     * Invites one to 20 comma-delimited recipients to an organisation with the shared organisation role.
     * @summary Invite organisation user
     */
    inviteOrganisationUser<
        TData = RecipientBatchResponseOfInviteOrganisationUserResponse,
    >(
        organisationId: string,
        inviteOrganisationUserRequest: InviteOrganisationUserRequest,
        options?: HttpClientBodyOptions
    ): Observable<TData>;
    inviteOrganisationUser<
        TData = RecipientBatchResponseOfInviteOrganisationUserResponse,
    >(
        organisationId: string,
        inviteOrganisationUserRequest: InviteOrganisationUserRequest,
        options?: HttpClientEventOptions
    ): Observable<HttpEvent<TData>>;
    inviteOrganisationUser<
        TData = RecipientBatchResponseOfInviteOrganisationUserResponse,
    >(
        organisationId: string,
        inviteOrganisationUserRequest: InviteOrganisationUserRequest,
        options?: HttpClientResponseOptions
    ): Observable<AngularHttpResponse<TData>>;
    inviteOrganisationUser<
        TData = RecipientBatchResponseOfInviteOrganisationUserResponse,
    >(
        organisationId: string,
        inviteOrganisationUserRequest: InviteOrganisationUserRequest,
        options?: HttpClientObserveOptions
    ): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
        if (options?.observe === 'events') {
            return this.http.post<TData>(
                `/@core/api/organisations/${organisationId}/users/invite`,
                inviteOrganisationUserRequest,
                {
                    ...(options as Omit<
                        NonNullable<typeof options>,
                        'observe'
                    >),
                    observe: 'events',
                }
            );
        }

        if (options?.observe === 'response') {
            return this.http.post<TData>(
                `/@core/api/organisations/${organisationId}/users/invite`,
                inviteOrganisationUserRequest,
                {
                    ...(options as Omit<
                        NonNullable<typeof options>,
                        'observe'
                    >),
                    observe: 'response',
                }
            );
        }

        return this.http.post<TData>(
            `/@core/api/organisations/${organisationId}/users/invite`,
            inviteOrganisationUserRequest,
            {
                ...(options as Omit<NonNullable<typeof options>, 'observe'>),
                observe: 'body',
            }
        );
    }
    /**
     * @summary Soft-deletes an organisation user.
     */
    removeOrganisationUser<TData = void>(
        organisationId: string,
        userId: string,
        options?: HttpClientBodyOptions
    ): Observable<TData>;
    removeOrganisationUser<TData = void>(
        organisationId: string,
        userId: string,
        options?: HttpClientEventOptions
    ): Observable<HttpEvent<TData>>;
    removeOrganisationUser<TData = void>(
        organisationId: string,
        userId: string,
        options?: HttpClientResponseOptions
    ): Observable<AngularHttpResponse<TData>>;
    removeOrganisationUser<TData = void>(
        organisationId: string,
        userId: string,
        options?: HttpClientObserveOptions
    ): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
        if (options?.observe === 'events') {
            return this.http.delete<TData>(
                `/@core/api/organisations/${organisationId}/users/${userId}`,
                {
                    ...(options as Omit<
                        NonNullable<typeof options>,
                        'observe'
                    >),
                    observe: 'events',
                }
            );
        }

        if (options?.observe === 'response') {
            return this.http.delete<TData>(
                `/@core/api/organisations/${organisationId}/users/${userId}`,
                {
                    ...(options as Omit<
                        NonNullable<typeof options>,
                        'observe'
                    >),
                    observe: 'response',
                }
            );
        }

        return this.http.delete<TData>(
            `/@core/api/organisations/${organisationId}/users/${userId}`,
            {
                ...(options as Omit<NonNullable<typeof options>, 'observe'>),
                observe: 'body',
            }
        );
    }
    /**
     * @summary Retrieves building access assignments for a user within an organisation.
     */
    getOrganisationUserBuildingAccess<
        TData = OrganisationUserBuildingAccessResponse,
    >(
        organisationId: string,
        userId: string,
        options?: HttpClientBodyOptions
    ): Observable<TData>;
    getOrganisationUserBuildingAccess<
        TData = OrganisationUserBuildingAccessResponse,
    >(
        organisationId: string,
        userId: string,
        options?: HttpClientEventOptions
    ): Observable<HttpEvent<TData>>;
    getOrganisationUserBuildingAccess<
        TData = OrganisationUserBuildingAccessResponse,
    >(
        organisationId: string,
        userId: string,
        options?: HttpClientResponseOptions
    ): Observable<AngularHttpResponse<TData>>;
    getOrganisationUserBuildingAccess<
        TData = OrganisationUserBuildingAccessResponse,
    >(
        organisationId: string,
        userId: string,
        options?: HttpClientObserveOptions
    ): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
        if (options?.observe === 'events') {
            return this.http.get<TData>(
                `/@core/api/organisations/${organisationId}/users/${userId}/building-access`,
                {
                    ...(options as Omit<
                        NonNullable<typeof options>,
                        'observe'
                    >),
                    observe: 'events',
                }
            );
        }

        if (options?.observe === 'response') {
            return this.http.get<TData>(
                `/@core/api/organisations/${organisationId}/users/${userId}/building-access`,
                {
                    ...(options as Omit<
                        NonNullable<typeof options>,
                        'observe'
                    >),
                    observe: 'response',
                }
            );
        }

        return this.http.get<TData>(
            `/@core/api/organisations/${organisationId}/users/${userId}/building-access`,
            {
                ...(options as Omit<NonNullable<typeof options>, 'observe'>),
                observe: 'body',
            }
        );
    }
    /**
     * Sets explicit building assignments for an organisation member. The request is a full replacement list: include only buildings that should remain assigned; omitting a building removes any existing explicit assignment.
     * @summary Update organisation user building access
     */
    updateOrganisationUserBuildingAccess<
        TData = OrganisationUserBuildingAccessResponse,
    >(
        organisationId: string,
        userId: string,
        updateOrganisationUserBuildingAccessRequest: UpdateOrganisationUserBuildingAccessRequest,
        options?: HttpClientBodyOptions
    ): Observable<TData>;
    updateOrganisationUserBuildingAccess<
        TData = OrganisationUserBuildingAccessResponse,
    >(
        organisationId: string,
        userId: string,
        updateOrganisationUserBuildingAccessRequest: UpdateOrganisationUserBuildingAccessRequest,
        options?: HttpClientEventOptions
    ): Observable<HttpEvent<TData>>;
    updateOrganisationUserBuildingAccess<
        TData = OrganisationUserBuildingAccessResponse,
    >(
        organisationId: string,
        userId: string,
        updateOrganisationUserBuildingAccessRequest: UpdateOrganisationUserBuildingAccessRequest,
        options?: HttpClientResponseOptions
    ): Observable<AngularHttpResponse<TData>>;
    updateOrganisationUserBuildingAccess<
        TData = OrganisationUserBuildingAccessResponse,
    >(
        organisationId: string,
        userId: string,
        updateOrganisationUserBuildingAccessRequest: UpdateOrganisationUserBuildingAccessRequest,
        options?: HttpClientObserveOptions
    ): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
        if (options?.observe === 'events') {
            return this.http.put<TData>(
                `/@core/api/organisations/${organisationId}/users/${userId}/building-access`,
                updateOrganisationUserBuildingAccessRequest,
                {
                    ...(options as Omit<
                        NonNullable<typeof options>,
                        'observe'
                    >),
                    observe: 'events',
                }
            );
        }

        if (options?.observe === 'response') {
            return this.http.put<TData>(
                `/@core/api/organisations/${organisationId}/users/${userId}/building-access`,
                updateOrganisationUserBuildingAccessRequest,
                {
                    ...(options as Omit<
                        NonNullable<typeof options>,
                        'observe'
                    >),
                    observe: 'response',
                }
            );
        }

        return this.http.put<TData>(
            `/@core/api/organisations/${organisationId}/users/${userId}/building-access`,
            updateOrganisationUserBuildingAccessRequest,
            {
                ...(options as Omit<NonNullable<typeof options>, 'observe'>),
                observe: 'body',
            }
        );
    }
    /**
     * Restores a removed organisation user as a pending invitation without restoring historical building access.
     * @summary Re-invite removed organisation user
     */
    reinviteOrganisationUserInvitation<TData = void>(
        organisationId: string,
        userId: string,
        reinviteOrganisationUserRequest: ReinviteOrganisationUserRequest,
        options?: HttpClientBodyOptions
    ): Observable<TData>;
    reinviteOrganisationUserInvitation<TData = void>(
        organisationId: string,
        userId: string,
        reinviteOrganisationUserRequest: ReinviteOrganisationUserRequest,
        options?: HttpClientEventOptions
    ): Observable<HttpEvent<TData>>;
    reinviteOrganisationUserInvitation<TData = void>(
        organisationId: string,
        userId: string,
        reinviteOrganisationUserRequest: ReinviteOrganisationUserRequest,
        options?: HttpClientResponseOptions
    ): Observable<AngularHttpResponse<TData>>;
    reinviteOrganisationUserInvitation<TData = void>(
        organisationId: string,
        userId: string,
        reinviteOrganisationUserRequest: ReinviteOrganisationUserRequest,
        options?: HttpClientObserveOptions
    ): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
        if (options?.observe === 'events') {
            return this.http.post<TData>(
                `/@core/api/organisations/${organisationId}/users/${userId}/invitation/reinvite`,
                reinviteOrganisationUserRequest,
                {
                    ...(options as Omit<
                        NonNullable<typeof options>,
                        'observe'
                    >),
                    observe: 'events',
                }
            );
        }

        if (options?.observe === 'response') {
            return this.http.post<TData>(
                `/@core/api/organisations/${organisationId}/users/${userId}/invitation/reinvite`,
                reinviteOrganisationUserRequest,
                {
                    ...(options as Omit<
                        NonNullable<typeof options>,
                        'observe'
                    >),
                    observe: 'response',
                }
            );
        }

        return this.http.post<TData>(
            `/@core/api/organisations/${organisationId}/users/${userId}/invitation/reinvite`,
            reinviteOrganisationUserRequest,
            {
                ...(options as Omit<NonNullable<typeof options>, 'observe'>),
                observe: 'body',
            }
        );
    }
    /**
     * Queues the existing invitation email for a pending organisation user.
     * @summary Resend organisation user invitation
     */
    createOrganisationUserInvitationResend<TData = void>(
        organisationId: string,
        userId: string,
        options?: HttpClientBodyOptions
    ): Observable<TData>;
    createOrganisationUserInvitationResend<TData = void>(
        organisationId: string,
        userId: string,
        options?: HttpClientEventOptions
    ): Observable<HttpEvent<TData>>;
    createOrganisationUserInvitationResend<TData = void>(
        organisationId: string,
        userId: string,
        options?: HttpClientResponseOptions
    ): Observable<AngularHttpResponse<TData>>;
    createOrganisationUserInvitationResend<TData = void>(
        organisationId: string,
        userId: string,
        options?: HttpClientObserveOptions
    ): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
        if (options?.observe === 'events') {
            return this.http.post<TData>(
                `/@core/api/organisations/${organisationId}/users/${userId}/invitation/resend`,
                undefined,
                {
                    ...(options as Omit<
                        NonNullable<typeof options>,
                        'observe'
                    >),
                    observe: 'events',
                }
            );
        }

        if (options?.observe === 'response') {
            return this.http.post<TData>(
                `/@core/api/organisations/${organisationId}/users/${userId}/invitation/resend`,
                undefined,
                {
                    ...(options as Omit<
                        NonNullable<typeof options>,
                        'observe'
                    >),
                    observe: 'response',
                }
            );
        }

        return this.http.post<TData>(
            `/@core/api/organisations/${organisationId}/users/${userId}/invitation/resend`,
            undefined,
            {
                ...(options as Omit<NonNullable<typeof options>, 'observe'>),
                observe: 'body',
            }
        );
    }
    /**
     * @summary Updates an organisation user's role.
     */
    updateOrganisationUserRole<TData = ChangeOrganisationUserRoleResponse>(
        organisationId: string,
        userId: string,
        changeOrganisationUserRoleRequest: ChangeOrganisationUserRoleRequest,
        options?: HttpClientBodyOptions
    ): Observable<TData>;
    updateOrganisationUserRole<TData = ChangeOrganisationUserRoleResponse>(
        organisationId: string,
        userId: string,
        changeOrganisationUserRoleRequest: ChangeOrganisationUserRoleRequest,
        options?: HttpClientEventOptions
    ): Observable<HttpEvent<TData>>;
    updateOrganisationUserRole<TData = ChangeOrganisationUserRoleResponse>(
        organisationId: string,
        userId: string,
        changeOrganisationUserRoleRequest: ChangeOrganisationUserRoleRequest,
        options?: HttpClientResponseOptions
    ): Observable<AngularHttpResponse<TData>>;
    updateOrganisationUserRole<TData = ChangeOrganisationUserRoleResponse>(
        organisationId: string,
        userId: string,
        changeOrganisationUserRoleRequest: ChangeOrganisationUserRoleRequest,
        options?: HttpClientObserveOptions
    ): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
        if (options?.observe === 'events') {
            return this.http.patch<TData>(
                `/@core/api/organisations/${organisationId}/users/${userId}/role`,
                changeOrganisationUserRoleRequest,
                {
                    ...(options as Omit<
                        NonNullable<typeof options>,
                        'observe'
                    >),
                    observe: 'events',
                }
            );
        }

        if (options?.observe === 'response') {
            return this.http.patch<TData>(
                `/@core/api/organisations/${organisationId}/users/${userId}/role`,
                changeOrganisationUserRoleRequest,
                {
                    ...(options as Omit<
                        NonNullable<typeof options>,
                        'observe'
                    >),
                    observe: 'response',
                }
            );
        }

        return this.http.patch<TData>(
            `/@core/api/organisations/${organisationId}/users/${userId}/role`,
            changeOrganisationUserRoleRequest,
            {
                ...(options as Omit<NonNullable<typeof options>, 'observe'>),
                observe: 'body',
            }
        );
    }
}
